import { DefinedEventsRequestTypes } from './types';
import { DefinedEventsActions } from './actions';
import {
  DefinedEventRecord,
  GetAllDefinedEventsResponse,
} from '@fullstory/proto/fs/services/search-settings';
import { createAccessReducer } from '../../../utils/accessControl';
import { createRequestReducer } from '@fullstory/redux-util';
import { ObjectDeps } from '@fullstory/proto/fs/services/dx-objects';
import { AppBackendActions, AppBackendRequestTypes } from '../../appbackend';

type State = Map<string, DefinedEventRecord>;

const depsToState = (deps: ObjectDeps | null, state: State): State => {
  if (!deps) return state;
  const newState = new Map(state);
  const { definedEvents } = deps;

  for (const [definedEventId, definedEvent] of Object.entries(definedEvents)) {
    if (definedEvent.definedEvent) {
      newState.set(definedEventId, definedEvent.definedEvent);
    }
  }

  return newState;
};

export function definedEventsReducer(
  state: State = new Map<string, DefinedEventRecord>(),
  action: DefinedEventsActions | AppBackendActions,
): State {
  switch (action.type) {
    case DefinedEventsRequestTypes.GetAllDefinedEventsSuccess: {
      const newState = new Map(state);
      action.data.definedEvents.forEach(de => {
        if (de.definedEvent?.definedEvent?.id) {
          newState.set(de.definedEvent.definedEvent.id, de.definedEvent);
        }
      });
      return newState;
    }
    case DefinedEventsRequestTypes.SetDefinedEventSuccess: {
      const newState = new Map(state);
      if (action.data.definedEvent?.definedEvent?.definedEvent?.id) {
        newState.set(
          action.data.definedEvent.definedEvent.definedEvent.id,
          action.data.definedEvent.definedEvent,
        );
      }
      return newState;
    }
    case DefinedEventsRequestTypes.ArchiveDefinedEventSuccess: {
      const newState = new Map(state);
      if (action.data.definedEvent?.definedEvent?.definedEvent?.id) {
        newState.set(
          action.data.definedEvent.definedEvent.definedEvent.id,
          action.data.definedEvent.definedEvent,
        );
      }
      return newState;
    }
    case AppBackendRequestTypes.GetSegmentDetailViewSuccess:
    case AppBackendRequestTypes.GetFunnelDetailViewSuccess:
    case AppBackendRequestTypes.GetSidebarSuccess: {
      return depsToState(action.data.deps, state);
    }
    default:
      return state;
  }
}

const definedEventsAccess = createAccessReducer(
  DefinedEventsRequestTypes.DefinedEventAccessRequest,
  DefinedEventsRequestTypes.DefinedEventAccessSuccess,
  DefinedEventsRequestTypes.DefinedEventAccessFailure,
);

const getAllDefinedEvents = createRequestReducer<GetAllDefinedEventsResponse>()(
  DefinedEventsRequestTypes.GetAllDefinedEventsRequest,
  DefinedEventsRequestTypes.GetAllDefinedEventsSuccess,
  DefinedEventsRequestTypes.GetAllDefinedEventsFailure,
);
export { definedEventsAccess, getAllDefinedEvents };
